import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.dropdown');
import { OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-dropdown',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/portal.infra.dropdown/view.scss */
:host {
  display: inline-block;
}`],
})
export class PortalInfraDropdownComponent implements OnInit, OnDestroy {
    @Input() items: any[] = [];
    @Input() value: string = '';
    @Input() label: string = 'Select';
    @Input() placeholder: string = 'Search...';
    @Input() searchable: boolean = true;
    @Input() width: string = 'w-64';
    @Input() icon: string = '';
    @Input() clearLabel: string = 'All';
    @Input() displayField: string = '';
    @Input() valueField: string = '';
    @Input() subDisplayField: string = '';
    @Output() valueChange = new EventEmitter<string>();
    @Output() onChange = new EventEmitter<string>();
    @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

    public open: boolean = false;
    public searchText: string = '';
    public highlightIndex: number = -1;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private elRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnDestroy() { }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        if (!this.elRef.nativeElement.contains(event.target)) {
            if (this.open) {
                this.open = false;
                this.service.render();
            }
        }
    }

    public get filteredItems() {
        if (!this.searchable || !this.searchText) return this.items;
        const q = this.searchText.toLowerCase();
        return this.items.filter((item: any) => {
            if (typeof item === 'string') return item.toLowerCase().includes(q);
            const display = this.displayField ? (item[this.displayField] || '').toLowerCase() : '';
            const val = this.valueField ? (item[this.valueField] || '').toLowerCase() : '';
            const sub = this.subDisplayField ? (item[this.subDisplayField] || '').toLowerCase() : '';
            return display.includes(q) || val.includes(q) || sub.includes(q);
        });
    }

    public getItemValue(item: any): string {
        if (typeof item === 'string') return item;
        return this.valueField ? item[this.valueField] : item;
    }

    public getItemDisplay(item: any): string {
        if (typeof item === 'string') return item;
        return this.displayField ? (item[this.displayField] || '') : JSON.stringify(item);
    }

    public getItemSub(item: any): string {
        if (!this.subDisplayField || typeof item === 'string') return '';
        return item[this.subDisplayField] || '';
    }

    public getSelectedDisplay(): string {
        if (!this.value) return '';
        const found = this.items.find((item: any) => this.getItemValue(item) === this.value);
        if (!found) return this.value;
        return this.getItemDisplay(found);
    }

    public toggle(e: Event) {
        e.stopPropagation();
        this.open = !this.open;
        this.searchText = '';
        this.highlightIndex = -1;
        if (this.open && this.searchable) {
            setTimeout(() => {
                this.searchInput?.nativeElement?.focus();
            }, 50);
        }
        this.service.render();
    }

    public select(val: string) {
        const newVal = this.value === val ? '' : val;
        this.value = newVal;
        this.valueChange.emit(newVal);
        this.onChange.emit(newVal);
        this.open = false;
        this.highlightIndex = -1;
    }

    public onSearchKeydown(event: KeyboardEvent) {
        const items = this.filteredItems;
        const total = items.length + 1; // +1 for "All" option

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.highlightIndex = (this.highlightIndex + 1) % total;
            this.scrollToHighlighted();
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.highlightIndex = (this.highlightIndex - 1 + total) % total;
            this.scrollToHighlighted();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.highlightIndex === 0) {
                this.select('');
            } else if (this.highlightIndex > 0 && this.highlightIndex <= items.length) {
                this.select(this.getItemValue(items[this.highlightIndex - 1]));
            }
        } else if (event.key === 'Escape') {
            this.open = false;
            this.highlightIndex = -1;
        }
        this.service.render();
    }

    private scrollToHighlighted() {
        setTimeout(() => {
            const el = this.elRef.nativeElement.querySelector('.dropdown-item-highlighted');
            if (el) el.scrollIntoView({ block: 'nearest' });
        }, 10);
    }
}

export default PortalInfraDropdownComponent;